//Library modul
import { Component } from "react";
import { connect } from "react-redux";

//Personal Component
// import TextFieldGroup from "../common_input/TextFieldGroup";
// import { SelectField } from "../common_input/TextFieldGroup";

//Redux function
import {
  logoutUser,
  registerUser,
  setErrors,
  usernameCheck,
} from "../../App/actions/authActions";
import { check_collaborators, join_collab_by_accesstoken } from "../../App/actions/license_actions";

//Picture Asset

//General Function
import dict from "../../Data/dict.json";
import RegisterStep1 from "./RegisterStep1";
import RegisterStep2 from "./RegisterStep2";
import RegisterStep3Page1 from "./RegisterStep3Page1";
import RegisterStep3Page2 from "./RegisterStep3Page2";

import capitalize_first_letter from "../../App/validation/capitalize_first_letter";
import domain_list from "../../Data/domain_list";
import { get_country_calling_codes } from "../../App/validation/countries";
import { Modal } from "../reuseable";
import { Button } from "@mui/material";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

const pages = [
  {
    step: 1,
    field_name: "organization",
  },
  {
    step: 1,
    field_name: "country",
  },
  {
    step: 2,
    field_name: "industry",
  },
  {
    step: 2,
    field_name: "objective",
  },
  {
    step: 3,
    field_name: "first_name",
  },
  {
    step: 3,
    field_name: "last_name",
  },
  {
    step: 3,
    field_name: "name",
  },
  {
    step: 4,
    field_name: "phone_number",
  },
  {
    step: 4,
    field_name: "password",
  },
  {
    step: 4,
    field_name: "password2",
  },
];
const phoneNumberList = get_country_calling_codes();

class Register extends Component {
  constructor() {
    super();
    this.state = {
      first_name: "",
      last_name: "",
      name: "",
      email: "x",
      phone_number: "",
      password: "",
      password2: "",
      errors: {},
      industry: "",
      redeem_code: "",
      // show_password: false,
      organization: "",
      country: "Indonesia",
      objective: "",
      code: "",

      modal_collab_confirmation: false,
      modal_full_member: false,
      collaborators: null,
      modal_you_already_member: false,
    };
  }

  // ORIGINAL CODE
  componentDidMount = async () => {
    await this.confirmation();

    const domain = this.props.auth.domain;
    const object_domain = domain_list?.[domain];
    const { organization = "", objective = "", industry = "" } = object_domain;

    this.setState({
      organization,
      objective,
      industry,
    });

    if (this.props.errors) {
      return {
        errors: this.props.errors,
      };
    } else {
      return null;
    }
  };

  redirect_to_dashboard = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete("code");
    const str = params.toString();
    if (str) this.props.history.push(`/?${str}`)
    else this.props.history.push(`/`)
  }

  toggle_modal_collab_confirmation = () => {
    const { modal_collab_confirmation } = this.state
    this.setState({
      modal_collab_confirmation: !modal_collab_confirmation
    })
  }

  toggle_modal_you_already_member = () => {
    const { modal_you_already_member } = this.state
    this.setState({
      modal_you_already_member: !modal_you_already_member
    })
  }

  toggle_modal_full_member = () => {
    const { modal_full_member } = this.state
    this.setState({
      modal_full_member: !modal_full_member
    })
  }

  join_collab_by_token = async () => {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const code = currentSearchParams.get("code");
    const { user } = this.props.auth;
    const _id = user._id;
    if (code) {
      await this.props.join_collab_by_accesstoken({
        collab_code: code,
        _id,
      });
    }
  };

  confirmation = async () => {
    // const currentSearchParams = new URLSearchParams(window.location.search);
    // const code = currentSearchParams.get("code");
    // const token = localStorage.token_mapid;
    // if (code) {
    //   const collaborators = await this.props.check_collaborators(code);
    //   if (collaborators) {
    //     if (!collaborators?.is_full) {
    //       if (token && this.props.auth?.user) {
    //         if (!collaborators?.is_already_member)
    //           this.toggle_modal_collab_confirmation();
    //         else {
    //           this.toggle_modal_you_already_member();
    //         }
    //       }
    //     } else {
    //       this.toggle_modal_full_member();
    //     }
    //     this.setState({ collaborators })
    //   }
    // } else if (token && this.props.auth?.user) {
    //   this.redirect_to_dashboard();
    // }

    const code = new URLSearchParams(window.location.search).get("code");
    const token = localStorage.token_mapid;
    const { auth, check_collaborators } = this.props;
    const isAuthenticated = Boolean(token && auth?.user);

    // jika tidak ada code di URL
    if (!code) {
      if (isAuthenticated) this.redirect_to_dashboard();
      return;
    }

    const collaborators = await check_collaborators(code);
    if (!collaborators) return;

    // kondisi ketika kuota penuh
    if (collaborators.is_full) {
      this.toggle_modal_full_member();
    } else if (isAuthenticated) {
      // user login & masih ada slot
      if (!collaborators.is_already_member) {
        this.toggle_modal_collab_confirmation();
      } else {
        this.toggle_modal_you_already_member();
      }
    }

    this.setState({ collaborators });

  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      JSON.stringify(prevProps?.errors) !== JSON.stringify(this.props?.errors)
    ) {
      this.setState({
        errors: this.props?.errors,
      });
    }

    const { country } = this.state;
    if (prevState.country !== country) {
      this.setState({
        phone_number: phoneNumberList.find(
          (item) => item.country_name === country
        ).calling_code,
      });
    }
  };

  onSubmit = async (e) => {
    e.preventDefault();

    const params = {};
    window?.location?.search
      .slice(1)
      ?.split("&")
      ?.forEach((item) => {
        const param = item?.split("=");
        const key = param?.[0];
        const value = param?.[1];
        params[key] = value;
      });
    const collab_code = params?.code;

    const { mode } = this.props;
    const {
      first_name,
      last_name,
      name,
      email,
      phone_number,
      password,
      password2,
      industry,
      redeem_code,
      organization,
      country,
      objective,
    } = this.state;
    let body = {
      full_name: `${first_name} ${last_name}`,
      name: name.toLowerCase().replace(/\s/g, ""),
      email,
      phone_number,
      password,
      password2,
      industry: industry,
      city: "Kota Bandung",
      organization,
      country,
      objective,
      collab_code,
    };
    if (this.props.kode) {
      body = {
        full_name: `${first_name} ${last_name}`,
        name: name.toLowerCase().replace(/\s/g, ""),
        email,
        phone_number,
        password,
        password2,
        industry: mode === "personal" ? "Research and Education" : industry,
        specialist_code: this.props.kode,
        city: "Kota Bandung",
        organization,
        country,
        objective,
        collab_code,
      };
    }

    if (collab_code) {
      const collaborators = await this.props.check_collaborators(collab_code);
      if (collaborators) {
        this.setState({ collaborators }, async () => {
          if (!collaborators?.is_full) {
            await this.props.registerUser(body, redeem_code);
          } else {
            this.toggle_modal_full_member();
          }
        })
      }
    } else {
      await this.props.registerUser(body, redeem_code);
    }

  };

  onChange = (e) => {
    let body = {};
    if (e.target.name === "name") {
      body = {
        [e.target.name]: e.target.value.replace(/\s/g, ""),
        errors: {
          ...this.state.errors,
        },
      };
    } else {
      body = {
        [e.target.name]: e.target.value,
        errors: {
          ...this.state.errors,
        },
      };
    }

    delete body.errors[e.target.name];
    this.setState(body);
    this.props.setErrors();
    this.error_handle(e.target.name, e.target.value);
  };

  set_error = (key, value) => {
    let errors = structuredClone(this.state.errors);
    errors[key] = value;
    this.setState({ errors });
  };

  remove_error = (key) => {
    let errors = structuredClone(this.state.errors);
    delete errors[key];
    this.setState({ errors });
  };

  error_handle = (field_name, value) => {
    const language = localStorage?.language ? localStorage?.language : "ina";
    if (!value) {
      const name = capitalize_first_letter(String(field_name)).replaceAll(
        "_",
        " "
      );
      if (name) {
        const text = dict[`${name} cannot be empty.`][language];
        return { field_name, text };
      }
    } else {
      this.remove_error(field_name);
    }
  };

  check_if_any_error = () => {
    const { set_registration_step, registration_step } = this.props;
    const { step } = registration_step;
    // cari error yang belum diketahui
    let errors_local = [];
    let error_texts = {};
    pages
      .filter((page) => page.step <= step)
      .forEach((field) => {
        const is_empty = !this.state?.[field.field_name];
        if (is_empty) {
          const { field_name, text } =
            this.error_handle(
              field?.field_name,
              !!this.state?.[field?.field_name]
            ) || {};

          error_texts[field_name] = text;
          errors_local.push(field);
        }
      });

    if (errors_local?.length > 0) {
      this.setState({
        errors: error_texts,
      });

      set_registration_step({
        step: errors_local?.[0]?.step,
      });
      return errors_local?.[0]?.step;
    }
    return false;
  };

  set_page_to_error = () => {
    const { set_registration_step } = this.props;

    // cek error yang sudah ada di state, kemudian ke halaman error tersebut
    for (let page of pages) {
      if (this.state.errors?.[page.field_name]) {
        set_registration_step({
          step: page.step,
        });
        break;
      }
    }
  };

  name_cb = async (e) => {
    const name = e.target.value;
    if (name) {
      await this.props.usernameCheck(name);
    }
  };

  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";

    // const industry_list = get_industries(language);

    // const industry_list_sorted = sortArray(industry_list, "title", true);

    const {
      errors,
      first_name,
      last_name,
      name,
      // email,
      phone_number,
      password,
      password2,
      // show_password,
      industry,
      // redeem_code,
      organization,
      country,
      objective,

      modal_collab_confirmation,
      modal_full_member,
      collaborators,
      modal_you_already_member
    } = this.state;

    const { registration_step, set_registration_step } = this.props;
    const { loading } = this.props.auth;

    const your_name = this.props.auth?.user?.full_name || this.props.auth?.user?.name || "";

    const { step } = registration_step;

    let iconButton;
    const kode = this.props.kode;
    let kode_content;
    if (kode) {
      kode_content = (
        <section style={{ marginBottom: "10px" }}>
          Kode specialist: <b>{kode}</b>
        </section>
      );
    }
    if (loading) {
      iconButton = (
        <button
          className="button background_black"
          type="submit"
          style={{
            padding: "5px 15px",
            backgroundColor: "#1265ae",
            marginTop: "1rem",
          }}
        >
          {dict["Registering..."][language]}
        </button>
      );
    } else {
      iconButton = (
        <button
          className="marginTop_20 rounded_5 bg_black text_white w_full h_50"
          type="submit"
          data-mapid="clickNext"
          onClick={async (e) => {
            const { errors } = this.state;
            if (Object.keys(errors)?.length > 0) {
              this.set_page_to_error();
            } else {
              if (step < 4) {
                const is_any_error = this.check_if_any_error();
                if (is_any_error) {
                  //ada error
                  set_registration_step({
                    step: is_any_error,
                  });
                } else {
                  //kalo nggak ada error
                  set_registration_step({
                    step: registration_step?.step + 1,
                  });
                }
              } else if (step === 4 && Object.keys(errors)?.length === 0) {
                this.onSubmit(e);
              }
            }
          }}
        >
          {step === 4 ? dict["Register"][language] : dict["Next"][language]}
        </button>
      );
    }

    let page_content = null;
    if (step === 1) {
      page_content = (
        <RegisterStep1
          country={country}
          organization={organization}
          onChange={this.onChange}
          errors={errors}
        />
      );
    } else if (step === 2) {
      page_content = (
        <RegisterStep2
          industry={industry}
          objective={objective}
          onChange={this.onChange}
          errors={errors}
        />
      );
    } else if (step === 3) {
      page_content = (
        <RegisterStep3Page1
          first_name={first_name}
          last_name={last_name}
          name={name}
          onChange={this.onChange}
          errors={errors}
          name_cb={this.name_cb}
        />
      );
    } else if (step === 4) {
      page_content = (
        <RegisterStep3Page2
          country={country}
          phone_number={phone_number}
          password={password}
          password2={password2}
          onChange={this.onChange}
          errors={errors}
        />
      );
    }

    const register_content = (
      <div>
        {kode_content}
        <div>
          {page_content}
          {iconButton}
        </div>
        <style>{`
           #bottom_bar{ display:none;}
        `}</style>
      </div>
    );

    // const default_content = (
    //   <div className="flex flex_col gap_10">
    //     <label>
    //       {dict["Select your account mode you want to register"][language]}
    //     </label>
    //     <section className="flex justify_center gap_10">
    //       <button
    //         className="button_inactive border padding_5 rounded_5 text_blue"
    //         onClick={() => handle_mode("personal")}
    //         data-mapid="clickPersonal"
    //       >
    //         Personal
    //       </button>
    //       <button
    //         className="button_inactive border padding_5 rounded_5 text_blue"
    //         data-mapid="clickCompany"
    //         onClick={() => handle_mode("company")}
    //       >
    //         Company
    //       </button>
    //     </section>
    //   </div>
    // );

    // let main_content = default_content;
    // if (mode !== "none") {
    //   main_content = register_content;
    // }

    let main_content = register_content;
    const text_collab_confirmation_content = dict["You are signed as _username_. Are you sure you want to join to _creator_'s collaboration as _username_?"][language]
      .replaceAll("_username_", your_name).replace("_creator_", collaborators?.user?.full_name || collaborators?.user?.name);
    const modal_collab_confirmation_content = modal_collab_confirmation &&
      <Modal
        modalSize="small"
        isOpen={modal_collab_confirmation}
        onClose={() => { this.props.logoutUser(); this.toggle_modal_collab_confirmation(); }}
        title="CONFIRMATION"
        content={<p>{text_collab_confirmation_content}</p>}
        footer={
          <>
            <Button onClick={() => this.join_collab_by_token()} variant="contained">Yes</Button>
            <Button onClick={() => { this.props.logoutUser(); this.toggle_modal_collab_confirmation(); }} variant="outlined">No</Button>
          </>
        }
      />

    const text_you_already_member_content = dict["You are signed as _username_. You are already a member of the _creator_'s collaboration."][language]
      .replaceAll("_username_", your_name).replace("_creator_", collaborators?.user?.full_name || collaborators?.user?.name);
    const you_already_member_content = modal_you_already_member &&
      <Modal
        modalSize="small"
        isOpen={modal_you_already_member}
        onClose={this.toggle_modal_you_already_member}
        title="INFORMATION"
        content={<p>{text_you_already_member_content}</p>}
        footer={
          <>
            <Button onClick={() => this.redirect_to_dashboard()} variant="contained">Ok</Button>
          </>
        }
      />

    const text_full_member_content = dict["The collaboration with _creator_ is already full."][language]
      .replace("_creator_", collaborators?.user?.full_name || collaborators?.user?.name);
    const modal_full_member_content = modal_full_member &&
      <Modal
        modalSize="small"
        isOpen={modal_full_member}
        onClose={this.toggle_modal_full_member}
        title="CAUTION"
        content={<p>{text_full_member_content}</p>}
        footer={
          <>
            <Button onClick={this.toggle_modal_full_member} variant="contained">OK</Button>
          </>
        }
      />

    return <main>
      {main_content}
      {modal_collab_confirmation_content}
      {modal_full_member_content}
      {you_already_member_content}
    </main>;
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default withRouter(connect(mapStateToProps, {
  registerUser,
  setErrors,
  usernameCheck,
  join_collab_by_accesstoken,
  check_collaborators,
  logoutUser
})(Register));
